import React, { Component } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';

export default class CategoryCard extends Component {
  render() {
    const { name, img } = this.props;

    return (
      <Link to={`products/${name}`}>
        <div className="named-card" style={{ backgroundImage: `url(${img})` }}>
          <div className="named-card_title">{name}</div>
        </div>
      </Link>
    );
  }
}
